import { Fragment } from "react";
import { Link } from "react-router-dom";

// Rendu Markdown léger et sûr (gras, italique, liens, listes, paragraphes) sans HTML brut.
const INLINE = /(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^)\s]+\))/g;

function inline(text, key) {
  return text.split(INLINE).filter(Boolean).map((part, i) => {
    const k = `${key}-${i}`;
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={k}>{inline(part.slice(2, -2), k)}</strong>;
    const link = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (link) {
      const [, label, href] = link;
      if (href.startsWith("/")) return <Link key={k} to={href} className="font-semibold text-[#0369A1] underline underline-offset-2">{label}</Link>;
      if (/^(https?:|mailto:|tel:)/.test(href)) return <a key={k} href={href} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#0369A1] underline underline-offset-2">{label}</a>;
      return <Fragment key={k}>{label}</Fragment>;
    }
    if (part.startsWith("*") && part.endsWith("*") && part.length > 2) return <em key={k}>{part.slice(1, -1)}</em>;
    return <Fragment key={k}>{part}</Fragment>;
  });
}

export function MiniMarkdown({ text }) {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw, i) => {
    const line = raw.trim();
    const item = line.match(/^([-*•]|\d+[.)])\s+(.*)$/);
    if (item) {
      const ordered = /\d/.test(item[1]);
      if (!list || list.ordered !== ordered) { list = { ordered, items: [] }; blocks.push(list); }
      list.items.push(item[2]);
      return;
    }
    list = null;
    if (line) blocks.push({ p: line.replace(/^#{1,4}\s+/, "") , heading: /^#{1,4}\s/.test(line) });
  });
  return (
    <div className="space-y-2">
      {blocks.map((b, i) => b.items
        ? (b.ordered
          ? <ol key={i} className="list-decimal space-y-1 pl-5">{b.items.map((t, j) => <li key={j}>{inline(t, `${i}-${j}`)}</li>)}</ol>
          : <ul key={i} className="list-disc space-y-1 pl-5">{b.items.map((t, j) => <li key={j}>{inline(t, `${i}-${j}`)}</li>)}</ul>)
        : <p key={i} className={b.heading ? "font-semibold text-[#0C4A6E]" : ""}>{inline(b.p, i)}</p>)}
    </div>
  );
}
